export default (shoppingCartType) => /^rrp_/i.test(shoppingCartType);
